<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, Text } from "@getprovi/craft-svelte";
  import { ShoppingBagSolid, DeliveryTruckSolid } from "@getprovi/craft-svelte-icons";
  import PickupOrDeliveryButton from "./PickupOrDeliveryButton.svelte";
  import { startCase, toLower } from "lodash";

  export let currentPickupLocation: { id: number; name: string };

  const dispatch = createEventDispatcher();

  function onChangeClick(): void {
    dispatch("openDrawer");
  }

  $: deliveryIsSelected = currentPickupLocation.id == null;
  $: pickupLocationName = currentPickupLocation.name
    ? startCase(toLower(currentPickupLocation.name))
    : "Pickup Location";
  $: infoText = deliveryIsSelected ? "Delivery" : `Pickup at ${pickupLocationName}`;
</script>

<div class="craft flex items-center gap-4 my-12" data-testid="pickup-or-delivery-info">
  <Icon
    iconName={deliveryIsSelected ? DeliveryTruckSolid : ShoppingBagSolid}
    color="neutral"
    size="icon-sm"
  />
  <Text color="neutral" size="sm">
    {infoText}
    <PickupOrDeliveryButton {onChangeClick} />
  </Text>
</div>
